export const clearStateAndExit = () => {
  if (typeof window !== `undefined`) {
    localStorage.removeItem("quizJson")
    localStorage.removeItem("userToken")
    localStorage.removeItem("quizProgress")
    localStorage.removeItem("sectionLength")
    localStorage.removeItem("currentSection")
    localStorage.removeItem("userAge")
    localStorage.removeItem("userGender")
    localStorage.removeItem("userName")
    localStorage.removeItem("subscription_id")
    localStorage.removeItem("account_user_name")
    localStorage.removeItem("customer_id")

    window.location = process.env.GATSBY_MAGENTO_URL
  }
}

